import { render, staticRenderFns } from "./Paso5View.vue?vue&type=template&id=6b2cd8dc&scoped=true&"
import script from "./Paso5View.vue?vue&type=script&lang=js&"
export * from "./Paso5View.vue?vue&type=script&lang=js&"
import style0 from "./Paso5View.vue?vue&type=style&index=0&id=6b2cd8dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2cd8dc",
  null
  
)

export default component.exports